export const WebHelper = {
    ApiAddress: "https://www.psychoterapia360.pl/wp-json/calendar",

    post: (adress, body, onok, onerror, onException) => {
        fetch(`${WebHelper.ApiAddress}/${adress}`, {
            body: JSON.stringify(body), method: "POST", credentials: "include", headers: {
                'Content-Type': 'application/json', withCredentials: true
            }
        }).then((result) => {
            if (result.ok) {
                    result.json().then(jsonData => onok(jsonData))
            }
            else {
                if (onerror !== undefined)
                    onerror(result);
            }
        }).catch((e) => {
            if(onException !== undefined)
                onException(e);
            else
                console.error(e);
        });
    },

    get: (adress, onok, onerror, onException) => {
        fetch(`${WebHelper.ApiAddress}/${adress}`, { method: "GET", headers: { 'Content-Type': 'application/json' }}).then((result) => {
            if (result.ok) {
                result.json().then(jsonData => onok(jsonData));
            }
            else {
                if (onerror !== undefined)
                    onerror(result);
            }
        }).catch((e) => {
            if(onException !== undefined)
                onException(e);
            else
                console.error(e);
        });
    },
}

export default WebHelper;